import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export const http = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_BACKEND}${process.env.VUE_APP_BASE_API}/`
})
